import { render, staticRenderFns } from "./InspectionResult.vue?vue&type=template&id=20752b2c&"
import script from "./InspectionResult.vue?vue&type=script&lang=js&"
export * from "./InspectionResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports